import { render, staticRenderFns } from "./ConventionAuthors.vue?vue&type=template&id=eddf3af6&"
import script from "./ConventionAuthors.vue?vue&type=script&lang=js&"
export * from "./ConventionAuthors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eddf3af6')) {
      api.createRecord('eddf3af6', component.options)
    } else {
      api.reload('eddf3af6', component.options)
    }
    module.hot.accept("./ConventionAuthors.vue?vue&type=template&id=eddf3af6&", function () {
      api.rerender('eddf3af6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/60100003-2/components/ConventionAuthors.vue"
export default component.exports